import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { api } from "@/lib/api";
import { IMAGES } from "@/lib/images";
import { Reveal, ExpertCard, inputCls } from "@/components/ui-bits";
import { DirectoryTabs } from "./ResearchConsultants";

export default function Experts() {
  const { t } = useLanguage();
  const [experts, setExperts] = useState([]);
  const [filters, setFilters] = useState({ search: "", country: "", specialization: "", degree: "", expertise: "", min_experience: "" });

  const load = () => {
    const params = Object.fromEntries(Object.entries(filters).filter(([, v]) => v !== ""));
    api.get("/experts", { params }).then((r) => setExperts(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);
  useEffect(() => {
    const id = setTimeout(load, 350);
    return () => clearTimeout(id);
  }, [filters]);

  const set = (k) => (e) => setFilters({ ...filters, [k]: e.target.value });

  return (
    <div data-testid="experts-page">
      <section className="hero-grain relative overflow-hidden bg-navy-950 py-24 lg:py-28">
        <img src={IMAGES.executive} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-950/50 to-navy-950" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
          <Reveal>
            <p className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-gold">{t("experts.eyebrow")}</p>
            <h1 className="max-w-3xl font-display text-4xl font-semibold text-white sm:text-5xl">{t("page.expertsTitle")}</h1>
            <p className="mt-5 max-w-2xl text-base text-slate-300 sm:text-lg">{t("page.expertsSub")}</p>
          </Reveal>
        </div>
      </section>

      <section className="py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
          <DirectoryTabs active="experts" />
          <Reveal className="mb-10 grid gap-4 rounded-lg border border-slate-200 bg-white p-5 shadow-sm sm:grid-cols-2 lg:grid-cols-6">
            <div className="relative lg:col-span-2">
              <Search className="absolute start-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <input data-testid="expert-search-input" value={filters.search} onChange={set("search")} placeholder={t("experts.searchPlaceholder")} className={`${inputCls} ps-9`} />
            </div>
            <input data-testid="expert-filter-country" value={filters.country} onChange={set("country")} placeholder={t("experts.filterCountry")} className={inputCls} />
            <input data-testid="expert-filter-specialization" value={filters.specialization} onChange={set("specialization")} placeholder={t("experts.filterSpecialization")} className={inputCls} />
            <input data-testid="expert-filter-degree" value={filters.degree} onChange={set("degree")} placeholder={t("experts.filterDegree")} className={inputCls} />
            <input data-testid="expert-filter-experience" value={filters.min_experience} onChange={set("min_experience")} placeholder={t("experts.filterExperience")} type="number" min="0" className={inputCls} />
          </Reveal>

          {experts.length === 0 ? (
            <p className="py-16 text-center text-slate-500" data-testid="experts-empty">{t("experts.empty")}</p>
          ) : (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-testid="experts-grid">
              {experts.map((e) => (
                <Reveal key={e.id}><ExpertCard expert={e} /></Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
